import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { SecurityService } from 'src/app/shared/services/security.service';

@Injectable()
export class HttpconfigInterceptor implements HttpInterceptor {
  private isTokenRefreshing = false;
  logoutUrl = '/auth';

  constructor(
    private securityService: SecurityService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request);
  }

  private setToken(request: HttpRequest<any>) {
    return request.clone({
      setHeaders: { Authorization: `Bearer ${this.securityService.getAccessToken()}` }
    });
  }
  private setCors(request: HttpRequest<any>) {
    return request.clone({
      setHeaders: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, Content-Type, Accept, Access-Control-Allow-Origin',
        'Access-Control-Allow-Credentials': 'true',
        Accept: '*/*'
      }
    });
  }
}
